function splitEmployeeText(text) {
  return String(text || '')
    .split('|')
    .map(function(part) { return part.trim(); });
}

function resolveEmployeeName(parts) {
  if (parts.length >= 4) return parts[1] || '-';
  if (parts.length >= 1) return parts[0] || '-';
  return '-';
}

function resolveEmployeePosition(parts) {
  if (parts.length >= 2) return parts[parts.length - 1] || '-';
  return '-';
}

function employeeResultTemplate(data) {
  if (!data.text) return data.text;

  var parts = splitEmployeeText(data.text);
  var name = resolveEmployeeName(parts);
  var position = resolveEmployeePosition(parts);

  return jQuery(
    '<div class="row">' +
      '<div class="col-8 py-0"><small>' + name + '</small></div>' +
      '<div class="col-4 py-0"><small>' + position + '</small></div>' +
    '</div>'
  );
}

function employeeSelectionTemplate(data) {
  if (!data.text) return data.text;

  var parts = splitEmployeeText(data.text);
  var name = resolveEmployeeName(parts);
  var position = resolveEmployeePosition(parts);

  return name + ' - ' + position;
}

function resolveEmployeePositionFromData(data) {
  var element = data && data.element ? data.element : null;

  if (element) {
    var attrPosition = element.getAttribute('position');

    if (attrPosition && attrPosition.trim() !== '') {
      return attrPosition.trim();
    }
  }

  return resolveEmployeePosition(splitEmployeeText(data && data.text ? data.text : ''));
}

function initializeSelect2Basic(){
  if ($('.select2').length) {
    $('.select2').select2({})
  }
}

function initializeSelect2Employee(){
  if ($('.select2-employee').length) {
    $('.select2-employee').select2({          
      placeholder: 'Select | Employee',
      templateResult: employeeResultTemplate,
      templateSelection: employeeSelectionTemplate
    });

    $('.select2-employee').on('select2:open', function () {
      if ($('.select2-sticky-top').length === 0) {
        let stickyDiv = `
          <div class="row select2-sticky-top">
            <div class="col-8 py-0">Name</div>
            <div class="col-4 py-0">Position</div>
          </div>
        `;
        $('.select2-results').prepend(stickyDiv);
      }
    });
  }
}

window.initializeSelect2EmployeeItem = function(){
  if ($('.select2-employee-item').length) {
    $('.select2-employee-item').select2({          
      placeholder: 'Select | Employee',
      templateResult: employeeResultTemplate,
      templateSelection: employeeSelectionTemplate
    });

    $('.select2-employee-item').on('select2:open', function () {
      if ($('.select2-sticky-top').length === 0) {
        let stickyDiv = `
          <div class="row select2-sticky-top">
            <div class="col-8 py-0">Name</div>
            <div class="col-4 py-0">Position</div>
          </div>
        `;
        $('.select2-dropdown').attr('style', 'min-width: 300px')
        $('.select2-results').attr('style', 'min-width: 300px');
        $('.select2-results').prepend(stickyDiv);
      }
    });

    $('.select2-employee-item').on('select2:select', function (data) {
      const $dom = $(this);
      const position = resolveEmployeePositionFromData(data.params.data) || '-';
      const $positionTarget = $dom.closest('tr').find('[autofill=position]');

      if ($positionTarget.length) {
        $positionTarget.text(position);
      }
    })
  }
}

window.initializeSelect2 = function() {
  initializeSelect2Basic()
  initializeSelect2Employee()
  initializeSelect2EmployeeItem()
};
